import Gambling from './Gambling';

export default Gambling;
